import axios from 'axios';

/*
  pra rodar como HTTPS local
  set HTTPS=true&&npm start

  set HTTPS=true&&set SSL_CRT_FILE=./.cert/cert.pem SSL_KEY_FILE=./.cert/key.pem&&npm start


  Implementação de SSL (https) no localhost.
  Link:
  mkcert - https://github.com/FiloSottile/mkcert

  cria uma pasta na raiz como .cert
  e coloca ela no gitignore /.cert

  Comando para instalar arquivos do certificado e chave no projeto:
  mkcert -key-file ./.cert/key.pem -cert-file ./.cert/cert.pem "localhost"

  Script "start" do package.json:
  HTTPS=true SSL_CRT_FILE=./.cert/cert.pem SSL_KEY_FILE=./.cert/key.pem react-scripts start


*/
///
export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
});
